import { Component, Input, OnInit } from '@angular/core';
import { ObsTypeData } from 'src/app/performance-dashboard/model/performance.model';
import { PerformanceService } from '../../../services/performance.service';
import { ConstantsService } from '../../../../shared/services/constants.service';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';

@Component({
  selector: 'ara-observation-types',
  templateUrl: './observation-types.component.html',
  styleUrls: ['./observation-types.component.css']
})
export class ObservationTypesComponent implements OnInit {
  @Input() ObservationTypeData;
  @Input() selectedUnit: any;
  @Input() year: any;
  @Input() MonthRange: any;
  clonedObservation: { [s: string]: ObsTypeData } = {};
  ObsTyData : any;
  DisableExport : boolean = false;

  constructor(private PDService: PerformanceService,private router: Router) { }

  ngOnInit(): void {

  }


  onRowEditInit(Obs: ObsTypeData) {
    this.clonedObservation[Obs.Id] = { ...Obs };
    this.DisableExport = true;
  }

  onRowEditSave(Obs: ObsTypeData, index: number) {
    if (Obs.Id > 0) {

      if (this.clonedObservation[Obs.Id].Conversation != Obs.Conversation) {
        this.ObservationTypeData[this.ObservationTypeData.length - 1].Conversation = this.ObservationTypeData[this.ObservationTypeData.length - 1].Conversation - this.clonedObservation[Obs.Id].Conversation + Obs.Conversation;
      }
      if (this.clonedObservation[Obs.Id].Safe != Obs.Safe) {
        this.ObservationTypeData[this.ObservationTypeData.length - 1].Safe = this.ObservationTypeData[this.ObservationTypeData.length - 1].Safe - this.clonedObservation[Obs.Id].Safe + Obs.Safe;
      }
      if (this.clonedObservation[Obs.Id].Act != Obs.Act) {
        this.ObservationTypeData[this.ObservationTypeData.length - 1].Act = this.ObservationTypeData[this.ObservationTypeData.length - 1].Act - this.clonedObservation[Obs.Id].Act + Obs.Act;
      }
      if (this.clonedObservation[Obs.Id].Observation != Obs.Observation) {
        this.ObservationTypeData[this.ObservationTypeData.length - 1].Observation = this.ObservationTypeData[this.ObservationTypeData.length - 1].Observation - this.clonedObservation[Obs.Id].Observation + Obs.Observation;
      }
      if (this.clonedObservation[Obs.Id].Unsafe != Obs.Unsafe) {
        this.ObservationTypeData[this.ObservationTypeData.length - 1].Unsafe = this.ObservationTypeData[this.ObservationTypeData.length - 1].Unsafe - this.clonedObservation[Obs.Id].Unsafe + Obs.Unsafe;
      }
      if (this.clonedObservation[Obs.Id].Condition != Obs.Condition) {
        this.ObservationTypeData[this.ObservationTypeData.length - 1].Condition = this.ObservationTypeData[this.ObservationTypeData.length - 1].Condition - this.clonedObservation[Obs.Id].Condition + Obs.Condition;
      }

      delete this.clonedObservation[Obs.Id];
    }
    this.DisableExport = Object.keys(this.clonedObservation).length > 0 ? true : false;
  }

  onRowEditCancel(Obs: ObsTypeData, index: number) {
    this.ObservationTypeData[index] = this.clonedObservation[Obs.Id];
    delete this.clonedObservation[Obs.Id];
    this.DisableExport = Object.keys(this.clonedObservation).length > 0 ? true : false;
  }

  GetObservationTypeSelectedDetails(UnitId,Unit,Column){
  
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,//this.child1.selectedUnit,
        "Year": this.year,//this.child1.year,
        "Months":this.MonthRange,//this.child1.MonthRange,
        "ModuleName":"Observation Type",
        "Component":Unit === "Total" ? 0 : UnitId,
        "Column":Column,
        "ComponentName":Unit
     }
    };

    this.PDService.getPDSelectedDetails(apiRequest,this.callbackMethodForGetObservationTypeSelectedDetails.bind(this));
  }
  callbackMethodForGetObservationTypeSelectedDetails(response){
    if(response.Success)
    this.ObsTyData = response.Result;
  }

  Redirect(value,UnitId)
  {
  //this.router.navigate(['/observation/make-observation/', value, { unitId:UnitId }])
  window.open(ConstantsService.URL.APP + ['/observation/make-observation/'+value+';unitId='+UnitId], '_self');
  }

  //BOC Pritesh
  exportToExcel()
  {

  let element = document.getElementById('ObservationTypesTableToExport');
  const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
  ws['!ref'] = ws['!ref'].replace('H','G');//to remove Actions Column
  /* generate workbook and add the worksheet */
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  /* save to file */  
  XLSX.writeFile(wb, "ObservationTypes.xlsx");

  }
  //EOC Pritesh

}
